const SectionComposition = (props) => {
  return (
    <div className={`normal-white py-5 ${props.bgColor}`}>
        {props.children}
    </div>
  )
}

export default SectionComposition